import {
    CONVERT_PRODUCT_SUCCESS,
    PRODUCT_MANAGEMENT_SC_LIST,
    INVENTORY_QUERY_LIST,
    INVENTORY_QUERY_LIST_INITIAL,
    INVENTORY_QUERY_LIST_FAILURE,
    INVENTORY_QUERY_MORE_SUCCESS,
    INVENTORY_QUERY_MORE_INITIAL,
    INVENTORY_QUERY_MORE_FAILURE,
} from 'Actions/inventoryQuery';

const initialState = {};
let payload = {};

export function inventoryQuery(state = initialState, action) {
    switch (action.type) {
        case PRODUCT_MANAGEMENT_SC_LIST:
            payload = action.payload.data;

            return Object.assign({}, state, {productManagementSCList: payload});

        case INVENTORY_QUERY_LIST:
        case INVENTORY_QUERY_LIST_INITIAL:
        case INVENTORY_QUERY_LIST_FAILURE:
        case INVENTORY_QUERY_MORE_SUCCESS:
        case INVENTORY_QUERY_MORE_INITIAL:
        case INVENTORY_QUERY_MORE_FAILURE:
        case CONVERT_PRODUCT_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };

        default:
            return state;
    }
}
